export default __webpack_public_path__ + "static/media/game_02_ok.5fc51fce.png";